<template>
  <div class="whs-hero__control whs-hero__control--calendar" ref="calendar">
    <div class="whs-hero__label">{{ labelText }}</div>
    <input
      class="whs-hero__input"
      @click="toggleCalendar"
      :value="checkInOut"
      readonly
      :placeholder="placeholderText"
      :class="{'is-set': checkInOut}"
      ref="input"
    />
    <div class="whs-hero__select-simulator whs-icon" :class="{'open': open}"></div>
    <transition name="fade">
      <div v-show="open" class="whs-calendar-container">
        <div class="whs-calendar-nav">
          <div class="whs-calendar-nav__back whs-icon" @click="nav(-1)"></div>
          <div class="whs-calendar-nav__title" v-html="currentMonths"></div>
          <div class="whs-calendar-nav__forward whs-icon" @click="nav(1)"></div>
        </div>
        <div class="whs-calendar-table">
          <div class="whs-calendar-month">
            <div v-for="day in i18n.day" :key="day" class="whs-calendar-week">{{ day }}</div>
            <template v-if="getInactiveDays(currentDate)">
              <div
                v-for="iday in getInactiveDays(currentDate)"
                :key="'i' + iday"
                class="whs-calendar-day--inactive"
              ></div>
            </template>
            <div
              v-for="day in daysInMonth(currentDate)"
              :key="day"
              :class="{active: isActive(day, currentDate), focused: isFocused(day, currentDate),
              disabled: isDisabled(day, currentDate)}"
              class="whs-calendar-day"
              @mouseover="setFocused(day, currentDate)"
              @mouseout="setFocused()"
              @click="setCheckIn(day, currentDate)"
            >{{ day }}</div>
          </div>
          <!-- <div class="whs-calendar-month">
            <div v-for="day in i18n.day" :key="day" class="whs-calendar-week">{{ day }}</div>
            <template v-if="getInactiveDays(nextDate)">
              <div
                v-for="iday in getInactiveDays(nextDate)"
                :key="'i' + iday"
                class="whs-calendar-day--inactive"
              ></div>
            </template>
            <div
              v-for="day in daysInMonth(nextDate)"
              :key="day"
              :class="{active: isActive(day, nextDate), focused: isFocused(day, nextDate)}"
              class="whs-calendar-day"
              @mouseover="setFocused(day, nextDate)"
              @click="setCheckIn(day, nextDate)"
            >{{ day }}</div>
          </div>-->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const i18n = {
  month: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  day: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
};

export default {
  name: 'Calendar',
  data: function() {
    return {
      open: false,
      currentDate: new Date(new Date().setHours(0, 0, 0, 0)),
      focusedDates: [],
      i18n
    };
  },
  created: function() {
    // console.log(this.$store.getters["hero/checkout"]);
    const vm = this;
    window.addEventListener('click', e => {
      if (
        (vm.$refs.calendar && vm.$refs.calendar.contains(e.target)) ||
        !vm.open
      )
        return;
      vm.closeCalendar();
    });
    if (this.daysInMonth(this.currentDate) === this.currentDate.getDate())
      this.nav(1);
  },
  computed: {
    ...mapState('hero', ['checkinDate', 'checkoutDate']),
    placeholderText: {
      get() {
        return !this.open
          ? 'Выберите даты'
          : this.checkinDate
          ? `${this.getLocaleDate(this.checkinDate)} - ...`
          : 'Заезд...';
      }
    },
    labelText: {
      get() {
        return !this.open
          ? this.checkInOut
            ? 'Заезд - Выезд'
            : ''
          : this.checkinDate && !this.checkoutDate
          ? `Выберите выезд`
          : 'Выберите заезд';
      }
    },
    checkInOut: {
      get() {
        if (!this.checkoutDate) return '';

        return `${this.getLocaleDate(this.checkinDate)} - ${this.getLocaleDate(
          this.checkoutDate
        )}`;
      }
    },
    currentMonths: {
      get() {
        return this.getLocaleMonth(this.currentDate);
      }
    },
    inactiveDays: {
      get() {
        return this.getInactiveDays(this.currentDate);
      }
    },
    nextDate: {
      get() {
        return this.nextMonth(this.currentDate);
      }
    }
  },
  methods: {
    dateToString(date) {
      return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(
        -2
      )}-${('0' + date.getDate()).slice(-2)}`;
    },
    getLocaleDate(date) {
      return [
        date.getDate(),
        i18n.month[date.getMonth()].slice(0, 3).toLowerCase()
        // date.getFullYear()
      ].join(' ');
    },
    getLocaleMonth(date) {
      return [i18n.month[date.getMonth()], date.getFullYear()].join(' ');
    },
    nextMonth(date, index = 1) {
      const _date = new Date(date);
      return new Date(_date.setMonth(_date.getMonth() + index));
    },
    getInactiveDays(date) {
      const _date = new Date(date);
      const day = new Date(_date.setDate(1)).getDay() - 1;
      return day >= 0 ? day : 6;
    },
    daysInMonth(date) {
      const _date = new Date(date);
      return 33 - new Date(_date.getFullYear(), _date.getMonth(), 33).getDate();
    },
    closeCalendar() {
      this.open = false;
      if (!this.checkoutDate) this.$store.commit('hero/updateCheckIn');
    },
    toggleCalendar() {
      this.open = !this.open;
    },
    nav(index) {
      this.currentDate = this.nextMonth(this.currentDate, index);
    },
    setCheckIn(day, date) {
      if (this.isDisabled(day, date)) return;
      const _date = new Date(date);
      _date.setDate(day);
      if (this.checkoutDate || !this.checkinDate)
        return this.$store.commit('hero/updateCheckIn', _date);

      if (this.dateToString(this.checkinDate) === this.dateToString(_date))
        return;

      this.$store.commit('hero/updateCheckOut', _date);
      this.closeCalendar();
    },
    isActive(day, date) {
      const _date = new Date(date);
      const dateString = this.dateToString(new Date(_date.setDate(day)));
      if (dateString === this.$store.getters['hero/checkin']) return true;

      if (!this.checkoutDate) return false;

      return this.focusedDates.includes(_date.setDate(day));
    },
    isFocused(day, date) {
      if (this.isDisabled(day, date)) return false;
      const _date = new Date(date);
      return this.focusedDates.includes(_date.setDate(day));
    },
    isDisabled(day, date) {
      return (
        new Date(new Date(date).setDate(day)).getTime() < new Date().getTime()
      );
    },
    setFocused(day, date) {
      if (!this.checkinDate || this.checkoutDate) return;

      if (!day) this.focusedDates = [];

      const a = this.checkinDate.getTime();
      const b = new Date(new Date(date).setDate(day)).getTime();

      const from = Math.min(a, b);
      const to = Math.max(a, b);
      const focused = [];

      for (let time = from; time <= to; time += 86400000) {
        focused.push(time);
      }
      this.focusedDates = focused;
    }
  }
};
</script>

<style scoped>
.whs-hero__control--calendar {
  flex: 2 1 233px;
}
.whs-hero__input {
  cursor: pointer;
}
.whs-calendar-container {
  width: calc(100% - 16px);
  z-index: 1;
  right: 8px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-bg-dark);
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
.whs-calendar-nav {
  width: 100%;
  margin-bottom: 12px;
  display: grid;
  grid-template-columns: 32px 1fr 32px;
  align-items: center;
  justify-items: center;
  height: 32px;
  line-height: 32px;
  background-color: var(--color-bg-dark);
}
.whs-calendar-nav__back,
.whs-calendar-nav__forward {
  width: 100%;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.whs-calendar-nav__back:before,
.whs-calendar-nav__forward:before {
  content: '\f053';
  align-self: stretch;
  font-size: 24px;
  width: 100%;
  padding: 4px;
  vertical-align: middle;
  background-color: var(--color-alt-5);
  color: var(--color-main);
  text-align: center;
}
.whs-calendar-nav__forward:before {
  content: '\f054';
}
/* .whs-calendar-nav__title {
} */
.whs-calendar-table {
  width: 233px;
  display: flex;
  background-color: var(--color-bg-dark);
}
.whs-calendar-month {
  flex: 1 0 calc(50% - 4px);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(7, 32px);
  grid-gap: 1px;
}
/* .whs-calendar-month:first-child {
  margin-right: 4px;
}
.whs-calendar-month:last-child {
  margin-left: 4px;
} */
.whs-calendar-week {
  height: 32px;
  line-height: 32px;
  text-align: center;
  background-color: var(--color-bg);
}
.whs-calendar-day {
  text-align: center;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
  cursor: pointer;
}
.whs-calendar-day.focused {
  background-color: var(--color-alt-5);
}
.whs-calendar-day.disabled {
  background-color: var(--color-bg-dark);
  color: var(--color-alt-5);
  outline: none;
  cursor: default;
}
.whs-calendar-day.active {
  background-color: var(--color-main);
  color: #fff;
}
.whs-calendar-day:hover {
  outline: 1px solid var(--color-main);
  background-color: var(--color-alt-5);
  color: var(--color-text);
}
.whs-calendar-day--inactive {
  height: 24px;
  line-height: 24px;
}
</style>